module.exports = __webpack_public_path__ + "static/img/iphone-qianyue.3e9565d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone-qianyue.png
// module id = svvv
// module chunks = 70